// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profileImage{border-radius:50%;height:20px;margin-left:2px;width:20px}`, "",{"version":3,"sources":["webpack://./stylesheets/profileImage.scss"],"names":[],"mappings":"AAAA,cACE,iBAAA,CACA,WAAA,CAEA,eAAA,CADA,UACA","sourcesContent":[".profileImage {\n  border-radius: 50%;\n  height: 20px;\n  width: 20px;\n  margin-left: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
